import React, { Fragment } from 'react'
import injectSheet from 'react-jss'
import styles from './context-menu.styles'
import DropMenu from 'pobble-components/dist/drop-menu'
import MoreButton from 'pobble-components/dist/more-button'
import { openConfirmationDialog } from 'pobble-components/dist/modal/confirmation-dialog'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faGlobe } from '@fortawesome/pro-regular-svg-icons/faGlobe'
import { faTrashAlt } from '@fortawesome/pro-regular-svg-icons/faTrashAlt'
import { faTimesCircle } from '@fortawesome/pro-regular-svg-icons/faTimesCircle'

const ContextMenu = ({
  classes,
  onDelete,
  onPublish,
  onUnpublish,
  status,
  canPublish
}) => (
  <DropMenu
    button={({ ref, togglePopover }) => (
      <MoreButton forwardedRef={ref} onClick={togglePopover} />
    )}>
    {({ Menu, MenuItem, IconHolder, Separator, closePopover }) => (
      <Menu>
        <Fragment>
          {canPublish && (
            <Fragment>
              {status === 'unpublished' && (
                <MenuItem
                  onClick={() => {
                    openConfirmationDialog({
                      bodyText: `Are you sure you want to publish this work to the world?`,
                      confirmText: `Publish`,
                      action: () => {
                        onPublish()
                      }
                    })
                  }}>
                  <IconHolder>
                    <FontAwesomeIcon icon={faGlobe} />
                  </IconHolder>
                  Publish
                </MenuItem>
              )}
              {status === 'published' && (
                <MenuItem
                  onClick={() => {
                    openConfirmationDialog({
                      theme: 'danger',
                      bodyText: `Are you sure you want to unpublish this work?`,
                      confirmText: `Unpublish`,
                      action: onUnpublish
                    })
                  }}>
                  <IconHolder>
                    <FontAwesomeIcon icon={faTimesCircle} />
                  </IconHolder>
                  Unpublish
                </MenuItem>
              )}
            </Fragment>
          )}

          <MenuItem
            className={classes.delete}
            onClick={() => {
              openConfirmationDialog({
                theme: 'danger',
                bodyText: `Are you sure you want to delete this work?`,
                confirmText: `Delete work`,
                action: onDelete
              })
              closePopover()
            }}>
            <IconHolder>
              <FontAwesomeIcon icon={faTrashAlt} />
            </IconHolder>
            Delete work
          </MenuItem>
        </Fragment>
      </Menu>
    )}
  </DropMenu>
)

export default injectSheet(styles)(ContextMenu)
